import { nanoid } from "nanoid";

export const generateBookletId = () => nanoid(10);
